module.exports = __webpack_amd_options__;



/*****************
 ** WEBPACK FOOTER
 ** ../~/webpack/buildin/amd-options.js
 ** module id = 150
 ** module chunks = 2
 **/